import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import type { IStopPoint } from '../../../../../models/stop-point.model';
import './style.scss';
import { StopPointType } from '../../../../../models/stop-point-type.enum';
import { t } from '../../../../../services/texts.service';

function StopPointMarker({ stopPoint }: { stopPoint: IStopPoint }) {
  if (!stopPoint.latitude || !stopPoint.longitude) {
    return null;
  }

  const icon = L.divIcon({
    className: 'div-icon stop-point-marker',
    iconSize: [42, 55],
    iconAnchor: [21, 55],
    html: `<div class="position-relative">
                         <span class="visually-hidden">${stopPoint.stopPointType === StopPointType.trainStop ? t.track : t.platform}</span>
                         <span class="position-absolute fg-white w-100" style="margin-top: 7px">${stopPoint.platform}</span>
                         <img src="/icons/leaflet/map-marker-empty-default-blue-800-blue-1000.svg" alt="" class="w-100 h-100" />
                       </div>`,
  });

  return <Marker key={stopPoint.gid} icon={icon} position={[stopPoint.latitude, stopPoint.longitude]} />;
}

export default StopPointMarker;
